// MHM-5.4 — Version watcher
// Polls /api/build-info every 60 seconds. If the server's build_stamp differs
// from this module's CURRENT_STAMP (evaluated once on tab load), a non-dismissible
// toast appears with a Reload action — killing the stale-tab class of bug forever.
//
// Mount: <VersionWatcher /> inside the top-level App tree (no props needed).

import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

// MUST track MicroLeadSubNav.BUILD_STAMP — both bump together. The build_info
// backend route reads MicroLeadSubNav.jsx as the single source of truth.
const CURRENT_STAMP = "APP-1.0-r7";
const POLL_MS = 60_000;
const TOAST_ID = "version-watcher";

export default function VersionWatcher() {
  const notified = useRef(false);
  useEffect(() => {
    const check = async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/build-info?t=${Date.now()}`;
        const r = await fetch(url, { cache: "no-store" });
        if (!r.ok) return;
        const { build_stamp } = await r.json();
        if (build_stamp && build_stamp !== CURRENT_STAMP && !notified.current) {
          notified.current = true;
          toast("New version available", {
            id: TOAST_ID,
            description: `Your tab is on ${CURRENT_STAMP} · server is on ${build_stamp}. Reload to update.`,
            duration: Infinity,
            action: {
              label: "Reload",
              onClick: () => window.location.reload(),
            },
            icon: <RefreshCw className="h-4 w-4 text-[#FF6B00]" />,
          });
        }
      } catch {
        // Network blip — ignore; next tick will retry.
      }
    };
    check();
    const id = setInterval(check, POLL_MS);
    return () => clearInterval(id);
  }, []);
  return null;
}
